export enum ImportDocumentState {
  pending = 0,
  processing = 1,
  success = 2,
  fail = 3,
}
